import { Theme } from '@mui/material';

export const getDealGroupRowSx = (expanded: boolean) => (theme: Theme) => {
  const dark = theme.palette.mode === 'dark';
  const borderColor = dark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.07)';
  return {
    backgroundColor: dark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.025)',
    '&:hover': {
      backgroundColor: dark ? 'rgba(255,255,255,0.07) !important' : 'rgba(0,0,0,0.05) !important',
    },
    '& td': {
      borderBottom: expanded ? `1px solid ${borderColor}` : 'none',
    },
  };
};

export const dealGroupCellSx = {
  px: 1.5,
  py: 0.75,
  verticalAlign: 'middle',
} as const;

export const dealGroupToggleSx = {
  mr: 0.75,
  p: 0.25,
} as const;
